export interface DosageMultiplierOption {
  value: number
  label: string
}

export const DOSAGE_MULTIPLIER_OPTIONS: DosageMultiplierOption[] = [
  { value: 1, label: 'Full' },
  { value: 0.5, label: 'Half' },
  { value: 0.25, label: 'Quarter' },
]
